import { render, staticRenderFns } from "./newLookVideo.vue?vue&type=template&id=c3e4cf1c&scoped=true&"
import script from "./newLookVideo.vue?vue&type=script&lang=js&"
export * from "./newLookVideo.vue?vue&type=script&lang=js&"
import style0 from "./newLookVideo.vue?vue&type=style&index=0&id=c3e4cf1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e4cf1c",
  null
  
)

export default component.exports